import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './pdfPreview.scss';
import { useGetPdf } from '../../../../hooks/useQuery/pdfBuilder';
import { updateCheckValue } from '../../../../actions/report';
import { useDispatch, useSelector } from 'react-redux';
import ReplayIcon from '@material-ui/icons/Replay';
import { Loader } from '@photocarbone/nooco-ui';

interface PdfPreviewProps {
  widgetsRef: React.MutableRefObject<undefined>;
}

function PdfPreview({ widgetsRef }: PdfPreviewProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { data: pdfDatas, isLoading, isFetching, remove } = useGetPdf(widgetsRef);
  const { openPdfBuilder } = useSelector((state) => state.report);

  useEffect(() => {
    if (!openPdfBuilder) {
      remove();
    }
  }, [openPdfBuilder]);

  const renderPdfPreview = (url: string) => {
    return (
      <iframe
        src={url}
        title="pdfPreview"
        style={{ width: '100%', height: '100%', backgroundColor: 'white' }}
      />
    );
  };

  return (
    <div className="border-section pdfPreview-wrapper" style={{}}>
      {isLoading || isFetching ? (
        <Loader />
      ) : pdfDatas && !isLoading ? (
        <>
          <ReplayIcon
            onClick={() => dispatch(updateCheckValue('generatePdfStarter', true))}
            style={{
              position: 'absolute',
              cursor: 'pointer',
              top: '-20px',
              right: '0px',
              color: 'black',
            }}
          />
          {renderPdfPreview(pdfDatas.previewUrl)}
        </>
      ) : (
        <button className="button-preview">
          <p onClick={() => dispatch(updateCheckValue('generatePdfStarter', true))}>
            {t('APP.PDF_BUILDER.PREVIEW', { defaultValue: 'Générer une preview' })}
          </p>
        </button>
      )}
    </div>
  );
}

export default PdfPreview;
